import { identity } from '@ipfabric/utils/utils/functions';
import type { FC } from 'react';
import { Overlay } from '../Overlay/Overlay';
import { SystemButton } from '../SystemButton/SystemButton';
import { useScrolledContentState } from '../hooks/useScrolledContentState';
import { getSidePanelClassNames } from './SidePanel.styles';
import type { SidePanelProps } from './SidePanel.types';

export const SidePanel: FC<SidePanelProps> = ({
  closeOnBackdropClick,
  title,
  onBack,
  children,
  footer,
  noHeader,
  onClose,
  size = 'default',
  className,
  wrapContent = identity,
  closeButtonTestId,
}) => {
  const { scrollableContentRef, scrolledContentState } =
    useScrolledContentState();

  const sidePanelClassNames = getSidePanelClassNames(
    size,
    scrolledContentState,
    className,
    title,
    Boolean(onBack),
  );

  return (
    <Overlay
      alignment='right'
      onClose={closeOnBackdropClick ? onClose : undefined}
    >
      {wrapContent(
        <div className={sidePanelClassNames.root}>
          {!noHeader && (
            <div className={sidePanelClassNames.header}>
              {onBack && (
                <SystemButton
                  icon='fa-angle-left'
                  onClick={onBack}
                  size='large'
                  className='-m-l text-default'
                  dataTestId='side-panel-back'
                />
              )}
              {title && (
                <h3 className='text-level-3 font-semibold m-0'>{title}</h3>
              )}
              <SystemButton
                icon='fa-close'
                onClick={onClose}
                size='large'
                className='ml-auto -m-r text-default'
                dataTestId={closeButtonTestId}
              />
            </div>
          )}
          <div
            ref={scrollableContentRef}
            className={sidePanelClassNames.content}
          >
            {typeof children === 'function'
              ? children({
                  closeModal: () => {
                    onClose();
                  },
                })
              : children}
          </div>
          {footer && (
            <div className={sidePanelClassNames.footer}>
              {typeof footer === 'function'
                ? footer({
                    closeModal: () => {
                      onClose();
                    },
                  })
                : footer}
            </div>
          )}
        </div>,
      )}
    </Overlay>
  );
};
